import MovieCard from "./MovieCard";

const ResultComp = ({ movieList, title }) => {
  if (!movieList) return null;
  let sortedByVoteCount = [...movieList].filter(
    (movie) => movie.backdrop_path !== null
  );
  sortedByVoteCount.sort((a, b) => b.vote_count - a.vote_count);

  return (
    <div className=" mx-12 ">
      <h1 className="text-lg md:text-3xl py-4 text-white opacity-70">
        {title}
      </h1>
      <div className="flex flex-wrap justify-start ">
        {sortedByVoteCount.length > 0 ? (
          sortedByVoteCount?.map((movie) => (
            <MovieCard movie={movie} key={movie.id} />
          ))
        ) : (
          <div className="text-2xl m-2 min-h-screen">
            No results?...check spelling
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultComp;
